import React from 'react';
import { connect } from 'react-redux';

import UserNavigation from './menus/UserNavigation';
import PublicNavigation from './menus/PublicNavigation';
import { account } from '../../../../../utils/propTypes';

function NavigationMenu({ currentUser }) {
  if (currentUser) {
    return <UserNavigation currentUser={currentUser} />;
  }
  return <PublicNavigation />;
}

NavigationMenu.propTypes = {
  currentUser: account,
};

NavigationMenu.defaultProps = {
  currentUser: null,
};

function mapStateToProps(state) {
  return {
    currentUser: state.auth.currentUser,
  };
}

export default connect(mapStateToProps)(NavigationMenu);



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/components/NavigationMenu/index.js